import { isPPL } from '@root/helpers/utils';

export const possibleValuesForOther = isPPL
  ? [
      'as_per_supporting_information_default_value',
      'see_supporting_information_default_value',
      'as_per_provision_type_description_default',
      'other',
      'other_not_classified',
      'Other',
      'reinsurance_other',
      'insurance_unspecified',
    ]
  : ['Other'];
